import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'Courier New', Courier, monospace",
  },
});

export default theme;
